var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIconSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2809_335",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0.5C5.5 0.223858 5.27614 0 5 0C4.72386 0 4.5 0.223858 4.5 0.5V1.00008C3.01747 1.00123 2.24038 1.02007 1.63803 1.32698C1.07354 1.6146 0.614601 2.07354 0.32698 2.63803C0.0565756 3.16873 0.00978897 3.83507 0.00169373 5H0V11.2C0 12.8802 0 13.7202 0.32698 14.362C0.614601 14.9265 1.07354 15.3854 1.63803 15.673C2.27976 16 3.11984 16 4.8 16H11.2C12.8802 16 13.7202 16 14.362 15.673C14.9265 15.3854 15.3854 14.9265 15.673 14.362C16 13.7202 16 12.8802 16 11.2V5H15.9983C15.9902 3.83507 15.9434 3.16873 15.673 2.63803C15.3854 2.07354 14.9265 1.6146 14.362 1.32698C13.7596 1.02007 12.9825 1.00123 11.5 1.00008V0.5C11.5 0.223858 11.2761 0 11 0C10.7239 0 10.5 0.223858 10.5 0.5V1H5.5V0.5ZM14.9982 5C14.9951 4.55447 14.9864 4.20463 14.9624 3.91104C14.9266 3.47262 14.8617 3.24842 14.782 3.09202C14.5903 2.71569 14.2843 2.40973 13.908 2.21799C13.7516 2.1383 13.5274 2.07337 13.089 2.03755C12.6935 2.00524 12.196 2.00072 11.5 2.0001V3C11.5 3.27614 11.2761 3.5 11 3.5C10.7239 3.5 10.5 3.27614 10.5 3V2H5.5V3C5.5 3.27614 5.27614 3.5 5 3.5C4.72386 3.5 4.5 3.27614 4.5 3V2.0001C3.80403 2.00072 3.3065 2.00524 2.91104 2.03755C2.47262 2.07337 2.24842 2.1383 2.09202 2.21799C1.71569 2.40973 1.40973 2.71569 1.21799 3.09202C1.1383 3.24842 1.07337 3.47262 1.03755 3.91104C1.01356 4.20463 1.00489 4.55447 1.00176 5H14.9982ZM1 6V11.2C1 12.0566 1.00078 12.6389 1.03755 13.089C1.07337 13.5274 1.1383 13.7516 1.21799 13.908C1.40973 14.2843 1.71569 14.5903 2.09202 14.782C2.24842 14.8617 2.47262 14.9266 2.91104 14.9624C3.36113 14.9992 3.94342 15 4.8 15H11.2C12.0566 15 12.6389 14.9992 13.089 14.9624C13.5274 14.9266 13.7516 14.8617 13.908 14.782C14.2843 14.5903 14.5903 14.2843 14.782 13.908C14.8617 13.7516 14.9266 13.5274 14.9624 13.089C14.9992 12.6389 15 12.0566 15 11.2V6H1Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2809_335)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIconSimple);
export default __webpack_public_path__ + "static/media/calendar-icon-simple.b19b84bfdd5c02c3223fbef8d8ba8d9a.svg";
export { ForwardRef as ReactComponent };